import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { WerkzoekenFeedRegistrationDto } from "./types";
import { jobSyncQueryKeys } from "../query-keys";

import { instance } from "@/lib/axios/instance";

export function useWerkzoekenFeedRegistration(
  clientId: string | undefined
): UseQueryResult<WerkzoekenFeedRegistrationDto, AxiosError> {
  return useQuery({
    queryKey: jobSyncQueryKeys.feedRegistration("werkzoeken", clientId),
    queryFn: () =>
      instance
        .get<WerkzoekenFeedRegistrationDto>(
          `/api/v2/Integrations/werkzoeken/job-sync/feed-registration`,
          {
            params: {
              clientId,
            },
          }
        )
        .then((res) => {
          const raw = res.data as unknown;
          const paginated = raw as { data?: WerkzoekenFeedRegistrationDto[]; Data?: WerkzoekenFeedRegistrationDto[] };
          if (Array.isArray(paginated?.data) && paginated.data[0] != null) return paginated.data[0];
          if (Array.isArray(paginated?.Data) && paginated.Data[0] != null) return paginated.Data[0];
          return raw as WerkzoekenFeedRegistrationDto;
        }),
    enabled: !!clientId,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
